import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IMaskModule } from 'angular-imask';
import { LogoFacilityComponent } from 'src/app/shared/components/logo-facility/logo.component';
import { ImageByFacilityComponent, InvalidFieldComponent } from '../../../components';
import { FacilityLocationsModule } from '../../facility-locations/facility-locations.module';
import { AWBSearchMaterialModule } from './awb-search-material-modules.module';
import { AwbSearchComponent } from './awb-search.component';
import { PaymentTypeSelectorComponent } from './payment-type-selector/payment-type-selector.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IMaskModule,
        LogoFacilityComponent,
        AWBSearchMaterialModule,
        InvalidFieldComponent,
        FacilityLocationsModule,
        ImageByFacilityComponent,
    ],
    declarations: [AwbSearchComponent, PaymentTypeSelectorComponent],
    exports: [AwbSearchComponent, PaymentTypeSelectorComponent],
})
export class AWBSearchModule {}
